import { useDealContext } from '@/finsight/application/Deal/DealContext';
import Spinner from '@dealroadshow/uikit/core/components/Loader/Spinner';
import CheckUserPlanAccess from '@/finsight/ui/common/components/CheckUserPlanAccess';
import RestrictedAccessExplanation from '@/finsight/ui/common/components/Explanations/RestrictedAccessExplanation/RestrictedAccessExplanation';
import { useDealTooltipContext } from '@/finsight/application/Deal/DealTooltipContext';
import { UserPlanType } from '@/users/domain/UserPlan';
import { ISSUE_LIST_EXPLAINATION_TITLE, ISSUE_LIST_EXPLAINATION_DESCRIPTION } from '@/finsight/ui/components/deals/constants';
import styles from './dealsList.scss';

const LOAD_MORE_BUTTON_ID = 'loadMoreButton';

const LoadMoreButton = () => {
    const { loadMore, isFetching } = useDealContext();
    const { dealTooltipOpened, setDealTooltipOpened } = useDealTooltipContext();
    const LoadMoreButtonContent = ({ onClick = loadMore }: { onClick?: React.MouseEventHandler<HTMLDivElement> }) => (
      <div className={ styles.moreWrapper } onClick={ onClick }>
        { isFetching
                ? <Spinner overlay />
                : <a className={ styles.moreBtn } data-test="dealsListLoadMoreButton">More</a> }
      </div>
    );

    return (
      <CheckUserPlanAccess
        requiredUserPlan={ UserPlanType.PREMIUM }
        fallback={ (
          <RestrictedAccessExplanation
            title={ ISSUE_LIST_EXPLAINATION_TITLE }
            description={ ISSUE_LIST_EXPLAINATION_DESCRIPTION }
            isOpen={ dealTooltipOpened === LOAD_MORE_BUTTON_ID }
            closeTooltip={ () => setDealTooltipOpened(null) }
          >
            <LoadMoreButtonContent onClick={ (e: React.MouseEvent<HTMLDivElement>) => {
              e.stopPropagation();
              setDealTooltipOpened(LOAD_MORE_BUTTON_ID);
            } }
            />
          </RestrictedAccessExplanation>
        ) }
      >
        <LoadMoreButtonContent />
      </CheckUserPlanAccess>
    );
};

export default LoadMoreButton;
